import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import ModelList from 'parog-web/components/model-list';
import OncoBreastCancer from 'parog-web/components/treatment-history/edition-form/chemotherapy-section/onco-breast-cancer';
import type FollowUpReason from 'parog-web/models/follow-up-reason';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    followUpReasonId: FollowUpReason['id'];
  };
}

const TreatmentHistoryEditionFormChemotherapyComponent: TOC<Signature> =
  <template>
    <h2 class='ui dividing header'>Chimiothérapie</h2>

    <div class='field' id='chemotherapies' data-test-chemotherapy-list>
      <ModelList
        @model={{@changeset}}
        @propertyName='chemotherapies'
        @addButtonTitle='Ajouter une chimiothérapie'
        as |Item|
      >
        <OncoBreastCancer @item={{Item}} @changeset={{@changeset}} />
      </ModelList>
    </div>
  </template>;
export default TreatmentHistoryEditionFormChemotherapyComponent;
